import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import * as utils from './Utils';



export function formatCartItem(itemRow) {
  let variantOptions = itemRow.payload.options;
  let variantTitle = variantOptions.join("/");

  let item = {};
  item['id'] = itemRow.id;
  item['title'] = variantTitle ? `${itemRow.label} (${variantTitle})` : itemRow.label;
  item['quantity'] = itemRow.quantity;
  item['price'] = parseFloat(itemRow.price.unitPrice);
  item['product_id'] = itemRow.productId;
  item['product_title'] = itemRow.label;
  item['variant_id'] = itemRow.variantId;
  item['variant_title'] = variantTitle;
  item['image_url'] = itemRow.cover && itemRow.cover.url || '';
  return item;
}


export function formatCartResponse(response) {
  let data = {};
  data['currency'] = window.OnVoardData.active_currency;
  data['total_price'] = parseFloat(response.price.totalPrice);

  let items = [];
  response.lineItems.forEach((itemRow) => {
    let item = formatCartItem(itemRow);
    items.push(item);
  })

  data['items'] = items;
  return data;
}


function getAddedCartItems(response) {
  const existingData = get(window.OnVoardEventsData, 'shopware_cart', {});
  const existingMapper = {};
  if (existingData.lineItems) {
    existingData.lineItems.forEach((itemRow) => {
      existingMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })
  }

  const currentMapper = {};
  if (response.lineItems) {
    response.lineItems.forEach((itemRow) => {
      currentMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })
  }

  let addedIds = utils.getAddedCartItemIds(existingMapper, currentMapper);
  let addedItems = [];
  if (response.lineItems) {
    response.lineItems.forEach((itemRow) => {
      let itemId = `${itemRow.id}`;
      if (!addedIds.includes(itemId)) return;
      addedItems.push(itemRow)
    })
  }

  return addedItems;
}


export function handleCartUpdate(response) {
  let noChange = isEqual(window.OnVoardEventsData['shopware_cart'], response);
  let isNew = !window.OnVoardEventsData['shopware_cart'] ? true : false;

  // no cart change
  if (noChange) return;

  // if first time loading, don't dispatch added cart items
  let addedCartItems = [];
  if (!isNew) addedCartItems = getAddedCartItems(response);

  window.OnVoardEventsData['shopware_cart'] = response;
  utils.dispatchCartUpdateEvent(response);
  addedCartItems.forEach((item) => {
    utils.dispatchAddCartItemEvent(item);
  })
}

function fetchCart(callback) {
  let ovItemsMapping = {};
  let ovInitialItems = {};
  let ovCart = {};

  fetch(window.OnVoardData["sw_storefront_url"] + '/store-api/checkout/cart', {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'sw-access-key': window.OnVoardData["sw_access_key"],
      'sw-context-token': window.OnVoardData["sw_context_token"]
    }
  })
  .then(res => res.json())
  .then(json => {
    ovCart = json;
    let ovCartVariantIds = [];

    ovInitialItems = json.lineItems;
    ovInitialItems.forEach((item) => {
      if (item.payload.options && item.payload.options.length > 0) {
        ovCartVariantIds.push(item.referencedId);
        ovItemsMapping[item.referencedId] = item;
        return;
      }

      item['productId'] = item.referencedId;
      item['variantId'] = null;
      ovItemsMapping[item.referencedId] = item;
    })

    if (ovCartVariantIds.length === 0) {
      return new Promise((resolve, reject) => {
        resolve(new Response(JSON.stringify({"elements":[]})));
      })
    }

    return fetch(window.OnVoardData["sw_storefront_url"] + '/store-api/product', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'sw-access-key': window.OnVoardData["sw_access_key"],
        'sw-context-token': window.OnVoardData["sw_context_token"]
      },
      body: JSON.stringify({
        "ids": ovCartVariantIds,
        "includes": {
          "product": [
            "id", "parentId", "productNumber"
          ]
        }
      })
    })
  })
  .then(res => res.json())
  .then(json => {
    json.elements.forEach((row) => {
      ovItemsMapping[row.id]['productId'] = row.parentId;
      ovItemsMapping[row.id]['variantId'] = row.id;
    })

    var ovNewLineItems = [];
    ovInitialItems.forEach((item) => {
      ovNewLineItems.push(ovItemsMapping[item.referencedId]);
    })

    ovCart.lineItems = ovNewLineItems;
    callback(ovCart);
    window.OnVoardData['cart'] = ovCart;
    window.OnVoardData['cartLoaded'] = true;
  });
}


export function setupCartUpdateEvent() {
  if (window.OnVoardEventsData.setupCartUpdateEvent) return;
  window.OnVoardEventsData.setupCartUpdateEvent = true;

  const triggerPaths = [
    "/checkout/line-item/add",
    "/checkout/line-item/delete",
    "/widgets/checkout/info",
    "/store-api/checkout/cart/line-item",
  ];

  let triggerCartUpdate = () => {
    let successCallback = (response) => {
      handleCartUpdate(response);
    };

    fetchCart(successCallback);
  };

  utils.interceptRequests(triggerPaths, (response, url) => {
    triggerCartUpdate();
  });
}

export function setupCheckoutOffCanvasEvent() {
  if (window.OnVoardEventsData.setupCheckoutOffCanvasEvent) return;
  window.OnVoardEventsData.setupCheckoutOffCanvasEvent = true;

  const triggerPaths = [
    "/widgets/checkout/info",
  ];

  utils.interceptRequests(triggerPaths, (response, url) => {
    let event = new CustomEvent("ov_shopware_checkout_offcanvas", {detail: response});
    document.dispatchEvent(event);
  });
}


export function loadCart() {
  let successCallback = (response) => {
    handleCartUpdate(response);
  };

  fetchCart(successCallback);
}
